import { useMutation } from '@tanstack/react-query';
import { 
  getStripeConnectLink, 
  verifyStripeOAuth, 
  getStripeDashboardLink 
} from '../api/worker';

/**
 * Generates a Stripe Connect onboarding link for the organization.
 * Use this when the user clicks "Connect Stripe" to redirect them to Stripe's hosted onboarding.
 */
export const useStripeConnectLink = () => {
  return useMutation({
    mutationFn: (nodeId: string) => getStripeConnectLink(nodeId),
  });
};

/**
 * Verifies the OAuth code returned by Stripe after the user completes onboarding.
 * Use this in the callback/return URL route (e.g., /settings/stripe/callback?code=xxx).
 */
export const useVerifyStripeOAuth = () => {
  return useMutation({
    mutationFn: ({ nodeId, code }: { nodeId: string; code: string }) => verifyStripeOAuth(nodeId, code),
  });
};

/**
 * Generates a login link to the Stripe Express Dashboard for connected accounts.
 * Use this when the user clicks "View Dashboard" or "Manage Payouts".
 */
export const useStripeDashboardLink = () => {
  return useMutation({
    mutationFn: (nodeId: string) => getStripeDashboardLink(nodeId),
  });
};